import { render, staticRenderFns } from "./Factory-order-progress.vue?vue&type=template&id=678d7d2a&scoped=true&"
import script from "./Factory-order-progress.vue?vue&type=script&lang=js&"
export * from "./Factory-order-progress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678d7d2a",
  null
  
)

export default component.exports